import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/products/industries/ex03.jpg")